import { Entity } from '@/interfaces'
import model from './model'
import repository from './repository'

const cmsNewsletterRegisterBlockEntity: Entity = {
  model: model,
  repository: repository,
}

export default cmsNewsletterRegisterBlockEntity
